const downloadFile = async (url: string | null | undefined): Promise<string | null> => {
    try {
        if (!url) {
            return null
        }
        const response = await fetch(url)
        const blob = await response.blob()
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onloadend = () => {
                resolve(reader.result as string)
            }
            reader.onerror = () => {
                reject(new Error('FileReader error'))
            }
            reader.readAsDataURL(blob)
        })
    } catch (error) {
        console.error('Error downloading file:', error)
        return null
    }
}

export default downloadFile
